// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__sBjam","modal":"Modal_modal__6uwIp","slide-down":"Modal_slide-down__g-tRj"};